
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/dashboard",
      function () {
        return require("private-next-pages/[locale]/dashboard/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/dashboard"])
      });
    }
  